<template>
  <div class="container">
    <div class="handle-wrapper">
      <Input
        v-model="searchText"
        search
        placeholder="搜索客户..."
        @on-change="searchSales"
        clearable
        icon="ios-search"
        style="width: 250px; margin-right: 20px"
      ></Input>
      <div style="margin-right: auto">
        <RadioGroup class="view-switch" v-model="view" type="button" @on-change="changeView">
          <Radio label="list">
            <Icon type="md-menu" />
          </Radio>
          <Radio label="card">
            <Icon type="ios-grid" />
          </Radio>
        </RadioGroup>
      </div>
      <span>共{{ totalRows }}条</span>
      <Page
        :total="totalRows"
        :page-size="15"
        @on-change="loadSales"
        show-total
        simple
        style="margin-right: 24px"
      />
      <Button
        v-if="
          currentUser.superAdmin ||
          arrayIntersection(['salesAssist'], currentUser.simpleRole).length > 0
        "
        type="primary"
        @click="openCreateSalesDrawer()"
      >新增销售项目</Button>
    </div>
    <div class="table-wrapper" v-if="view === 'list'" ref="tableWrapper">
      <Table :columns="columns" :data="tableData" :height="tableHeight">
        <template
          slot-scope="{ row }"
          slot="action"
          v-if="
            currentUser.superAdmin ||
            arrayIntersection(
              [
                'factoryLeader',
                'technologyLead',
                'technology',
                'allFactoryLeader',
              ],
              currentUser.simpleRole
            ).length > 0
          "
        >
          <Button
            type="info"
            ghost
            size="small"
            icon="ios-funnel"
            @click="$refs.RecipeDrawer.openDrawer(row)"
          >配方</Button>
        </template>
      </Table>
    </div>
    <div class="card-wrapper" v-if="view === 'card'">
      <div class="card-content">
        <div class="card-item" v-for="item in tableData" :key="item._id">
          <Card style="width: 300px">
            <p slot="title">{{ item.abbr }}</p>
            <div v-if="item.prodRecipe">
              <h3>#{{ item.prodRecipe.NoId }} {{ item.prodRecipe.name }}</h3>
              <div class="item">
                <div>创建人</div>
                <div>{{ item.prodRecipe.createdBy.name }}</div>
              </div>
              <div class="item">
                <div>审核人</div>
                <!-- <div>{{ item.prodRecipe.verifiedBy.name }}</div> -->
              </div>
              <div class="item">
                <div>审核情况</div>
                <div>{{ item.prodRecipe.status }}</div>
              </div>
              <div class="item">
                <div>审核时间</div>
                <div>{{ item.prodRecipe ? item.prodRecipe.verifiedAt : "" }}</div>
              </div>
              <Table :columns="cardColumns" :data="item.prodRecipe.detail" border></Table>
            </div>
            <div v-else>暂无生产配方</div>
          </Card>
        </div>
      </div>
    </div>
    <CreateSalesDrawer ref="CreateSalesDrawer" />
    <RecipeDrawer ref="RecipeDrawer" />
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import CreateSalesDrawer from "./CreateSalesDrawer.vue";
import RecipeDrawer from "./RecipeDrawer.vue";
import { arrayIntersection } from "@/utils";
import dayjs from "dayjs";
import _ from "lodash";

const statusToText = {
  reviewing: "待审核",
  verified: "合格",
  rejected: "不合格",
  canceled: "取消配方"
};
export default {
  name: "Sales",
  components: { CreateSalesDrawer, RecipeDrawer },
  data() {
    return {
      page: 0,
      searchText: "",
      tableLoading: false,
      digit: 0,
      showSupplying: "正在供货",
      tableData: [],
      columns: [
        {
          title: "行",
          key: "row",
          width: 60,
          align: "center",
          render: (h, params) =>
            h(
              "span",
              { style: { color: "darkgray" } },
              this.page * 15 + params.index + 1
            )
        },
        {
          title: "项目代称",
          key: "abbr",
          render: (h, params) => {
            if (
              this.currentUser.superAdmin ||
              arrayIntersection(["salesAssist"], this.currentUser.simpleRole)
                .length > 0
            ) {
              return h("div", [
                h(
                  "h4",
                  {
                    props: {
                      type: "text",
                      size: "small"
                    },
                    style: {
                      cursor: "pointer",
                      color: "#42b983"
                    },
                    on: {
                      click: () => {
                        this.$refs.CreateSalesDrawer.openDrawer(params.row);
                      }
                    }
                  },
                  params.row.abbr
                    ? params.row.abbr
                    : params.row.customer.name +
                        " — " +
                        params.row.material.model
                )
              ]);
            } else {
              return h(
                "h4",
                params.row.abbr
                  ? params.row.abbr
                  : params.row.customer.name + " — " + params.row.material.model
              );
            }
          }
        },
        {
          title: "操作",
          key: "action",
          slot: "action"
        },
        {
          title: "公司",
          key: "company",
          render: (h, params) => {
            return h("div", [h("span", params.row?.company?.name)]);
          }
        },
        {
          title: "客户",
          key: "customer",
          render: (h, params) => {
            return h("div", [
              h(
                "h4",
                {
                  props: {
                    type: "text",
                    size: "small"
                  }
                },
                params.row.customer.name
              )
            ]);
          }
        },
        {
          title: "产品",
          key: "material",
          align: "left",
          render: (h, params) =>
            h(
              "span",
              `${params.row.material.model} ${params.row.material.name}`
            )
        },
        {
          title: "发货工厂",
          key: "factory",
          align: "left",
          render: (h, params) =>
            h("span", `${params.row.factory ? params.row.factory.name : ""}`)
        },
        {
          title: "利润归属公司",
          key: "profitBelongCompany",
          render: (h, params) => {
            return h("div", [h("span", params.row?.profitBelongCompany?.name)]);
          }
        },
        {
          title: "公司内部项目",
          key: "internalShipping",
          align: "center",
          width: 100,
          render: (h, params) => {
            return h("span", params.row.internalShipping ? "是" : "");
          }
        }
      ],
      tableHeight: 300,
      cardColumns: [
        {
          title: "原材料",
          key: "material",
          render: (h, params) => {
            return h("div", [
              h(
                "h4",
                params.row.material.model
                  ? params.row.material.model
                  : params.row.material.name
              )
            ]);
          }
        },
        {
          title: "比例",
          key: "ratio",
          align: "right",
          render: (h, params) => {
            return h("div", [
              h("h4", (params.row.ratio * 100).toFixed(2) + "%")
            ]);
          }
        }
      ],
      view: "list"
    };
  },
  computed: mapState({
    totalRows: state => state.sales.totalCounts,
    currentUser: state => state.auth.currentUser
  }),
  methods: {
    arrayIntersection(array, targetArray) {
      return arrayIntersection(array, targetArray);
    },
    ...mapActions({
      getSales: "sales/getSalesAction",
      getMaterials: "material/getMaterialsAction",
      getCompanyList: "company/getCompanyListAction",
      getFactoryList: "factory/getFactorysAction"
    }),
    async loadSales(page) {
      const id = this.$route.query.id;
      if (page) this.page = page - 1;
      let api = {
        skip: this.page * 15,
        limit: 15
      };
      api.customer = id;

      if (this.searchText) api.cus_name = this.searchText;
      if (this.view === "card") {
      }
      try {
        this.tableLoading = true;
        const data = await this.getSales({ ...api, with_recipe: true });
        data.salesList.forEach(item => {
          if (item.prodRecipe) {
            item.prodRecipe.verifiedAt = dayjs(
              item.prodRecipe.verifiedAt
            ).format("YYYY-MM-DD HH:mm");
            item.prodRecipe.status = statusToText[item.prodRecipe.status];
            const total = {
              material: {},
              ratio: null
            };
            total.material.name = "材料合计";
            total.ratio = item.prodRecipe.detail.reduce((p, c) => {
              return p + c.ratio;
            }, 0);
            item.prodRecipe.detail.push(total);
          }
        });
        this.tableData = data.salesList;
        this.tableLoading = false;
      } catch (error) {
        this.$Message.error(`加载失败: ${error}`);
        this.tableLoading = false;
      }
    },
    searchSales: _.debounce(function() {
      this.page = 0;
      this.loadSales();
    }, 1000),
    openCreateSalesDrawer() {
      this.$refs.CreateSalesDrawer.openDrawer();
    },
    changeView(e) {
      this.$router.push({
        path: "/home/sales",
        query: {
          view: e
        }
      });
    }
  },
  created() {
    this.loadSales();
    this.getCompanyList({skip: 0, limit: 99});
    this.getFactoryList({});
  },
  mounted() {
    this.tableHeight = this.$refs.tableWrapper.offsetHeight;
    window.onresize = () => {
      this.tableHeight = this.$refs.tableWrapper.offsetHeight;
    };
    const view = this.$route.query.view;
    if (view) {
      this.view = view;
    }
  },
  destroyed() {
    window.onresize = null;
  }
};
</script>

<style scoped lang="stylus">
.handle-wrapper
  width 100%
  height 48px
  display flex
  align-items center
  justify-content flex-end

.table-wrapper
  width 100%
  height calc(100% - 48px)

.view-switch
  height 32px

.button-group
  display flex

.container
  overflow-y auto

.card-content
  display flex
  flex-wrap wrap

.card-item
  margin 0 20px 20px 0

.item
  display flex
  justify-content space-between
</style>
